export const STATEMENT_GET_STATEMENT = "statement/list/STATEMENT_GET_STATEMENT";
export const STATEMENT_GET_STATEMENT_RESULT = "statement/list/STATEMENT_GET_STATEMENT_RESULT";